
import { useEffect, useRef } from "react";

interface ResponseContentProps {
  content: string;
  onChange: (content: string) => void;
}

const ResponseContent = ({ content, onChange }: ResponseContentProps) => {
  const editorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Ensure content is properly set in the editor when it changes externally
    if (editorRef.current && editorRef.current.innerHTML !== content) {
      editorRef.current.innerHTML = content;
    }
  }, [content]);

  return (
    <div 
      ref={editorRef}
      className="min-h-[200px] p-4 border rounded-md bg-background prose max-w-none whitespace-pre-wrap"
      contentEditable
      dir="auto"
      lang="auto"
      spellCheck="false"
      onInput={(e) => {
        // Update on input rather than blur for more responsive feedback
        onChange(e.currentTarget.innerHTML);
      }}
      onBlur={(e) => {
        // Ensure content is updated when editor loses focus
        onChange(e.currentTarget.innerHTML);
      }}
      style={{ outline: 'none' }}
    />
  );
};

export default ResponseContent;
